export default __webpack_public_path__ + "static/media/britam.00b240d0.jpg";